<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :searchable="false"
      :filters="filters"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader>
        <b-col>
          <b-form-group
            :label="$t('general.user')"
          >
            <v-select-custom
              v-model="userId"
              :options="userOptions"
              :custom-props="{ label: 'fullName' }"
              @open="fetchUsersByRole({ role: 'user' })"
              @search="fetchUsersByRole({ role: 'user', 'search' : $event })"
            />
          </b-form-group>
        </b-col>
      </template>

      <!-- Column: status -->
      <template #cell(status)="{ item }">
        <pill-icon-cell
          :status="$t(`counselings.${item.status}`)"
          :options="statusOptions"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row
          v-if="isViewable('update', 'counseling')"
          @click.native="toEditPage(item._id)"
        />
        <!-- <delete-row v-if="isViewable('delete', 'counseling')" @click.native="deleteItem(item._id)" /> -->
        <view-row
          v-if="isViewable('create', 'counseling')"
          :class="item.viewConsultIds.includes(userData.id) ? '' : 'eyeColor' "
          @click.native="$router.push({name: `pages-counseling-messages`,params: { id: item._id } })"
        />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import { BCol, BFormGroup } from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import ViewRow from '@/components/BDataTable/Actions/ViewRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import PillIconCell from '@/components/BDataTable/Elements/PillIconCell.vue'
import VSelectCustom from '@/components/VSelectCustom/index.vue'
import useCounselingsList from './useCounselingsList'

export default {
  name: 'CounselingsList',
  components: {
    BCol,
    BDataTable,
    BFormGroup,
    EditRow,
    LayoutLoading,
    PillIconCell,
    VSelectCustom,
    ViewRow,
  },
  setup() {
    const {
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
      fetchUsersByRole,
      isViewable,
    } = useCounselingsList('counseling/empty/emptyCounseling')
    return {
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      statusOptions,
      tableColumns,
      toEditPage,
      userOptions,
      isViewable,
      fetchUsersByRole,
    }
  },
  data() {
    return {
      consultantOptions: [],
      consultantId: null,
      userId: null,
      userData: getUserData() || {},
    }
  },
  computed: {
    filters() {
      return {
        userId: this.userId && this.userId._id,
      }
    },
  },
  watch: {
    userId() {
      this.refTable.refetchData()
    },
  },
  created() {
    this.fetchUsersByRole({
      role: 'user',
    }).then(res => {
      this.userOptions = res
    })
  },
  methods: {
    searchUser(search) {
      this.fetchUsersByRole({
        role: 'user',
        search,
      }).then(res => {
        this.userOptions = res
      })
    },
  },
}
</script>
<style scoped>
.eyeColor{
  fill: #6ad38c !important;
  opacity: 1 ;
}
@media (max-width : 1199px){
  .feather-edit{
    margin-bottom: 20px;
    margin-right: 1rem !important;
}
}
</style>
